import React from 'react'

const ApplicationFakhry = () => {
  return (
    <iframe src='https://app.twin-park.tn/#/signin' allowfullscreen style={{width: "100%", height: "1024px"}}/>
  )
}

export default ApplicationFakhry
